import { Model } from '@nozbe/watermelondb'
import { field, json } from '@nozbe/watermelondb/decorators'


const sanitizeData = rawData => rawData

export class MilkQualitiesModel extends Model {

  static table = 'milkQualities'

  @field('milkQualityId')
  milkDeliveryId: string

  @field('dairyFarmId')
  dairyFarmId: string

  @field('ccs')
  ccs: number

  @field('ctb')
  ctb: number

  @field('ccsLimit')
  ccsLimit: number

  @field('ctbLimit')
  ctbLimit: number

  @field('organizationId')
  organizationId: string

  @field('manual')
  manual: boolean

  @field('userDocument')
  userDocument: string

  @field('date')
  date: string

  @field('protein')
  protein: string

  @field('fat')
  fat: string

  @field('proteinLimit')
  proteinLimit: string

  @field('fatLimit')
  fatLimit: string

  @field('userStateRegistrationId')
  userStateRegistrationId: string

  @field('nul')
  nul: string

  @field('lactose')
  lactose: string

  @json('groupedItems', sanitizeData)
  groupedItems

  @field('createdAt')
  createdAt: string

  @field('updatedAt')
  updatedAt: string

}
